/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestEasyMath, TestEasyMathInterface } from "../TestEasyMath";

const _abi = [
  {
    inputs: [],
    name: "ZeroAssets",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroShares",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "share",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShares",
        type: "uint256",
      },
    ],
    name: "toAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "share",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShares",
        type: "uint256",
      },
    ],
    name: "toAmountRoundUp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShares",
        type: "uint256",
      },
    ],
    name: "toShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShares",
        type: "uint256",
      },
    ],
    name: "toShareRoundUp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610330806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c8063535d90c41461005157806363bacbc0146100765780639f11bdd214610089578063b6602ada1461009c575b600080fd5b61006461005f366004610243565b6100af565b60405190815260200160405180910390f35b610064610084366004610243565b6100c6565b610064610097366004610243565b6100d3565b6100646100aa366004610243565b6100e0565b60006100bc8484846100ed565b90505b9392505050565b60006100bc848484610148565b60006100bc8484846101a6565b60006100bc848484610203565b60008115806100fa575082155b156101065750826100bf565b60006101128386610285565b9050600061012085836102ba565b905061012c85836102ce565b1561013f5761013c6001826102e2565b90505b95945050505050565b6000811580610155575082155b15610162575060006100bf565b60008261016f8587610285565b61017991906102ba565b90508015801561018857508415155b156100bc57604051630cb65c7760e21b815260040160405180910390fd5b60008115806101b3575082155b156101bf5750826100bf565b6000836101cc8487610285565b6101d691906102ba565b9050801580156101e557508415155b156100bc57604051639811e0c760e01b815260040160405180910390fd5b6000811580610210575082155b1561021d575060006100bf565b60006102298486610285565b9050600061023784836102ba565b905061012c84836102ce565b60008060006060848603121561025857600080fd5b505081359360208301359350604090920135919050565b634e487b7160e01b600052601160045260246000fd5b600081600019048311821515161561029f5761029f61026f565b500290565b634e487b7160e01b600052601260045260246000fd5b6000826102c9576102c96102a4565b500490565b6000826102dd576102dd6102a4565b500690565b600082198211156102f5576102f561026f565b50019056fea264697066735822122071b356db8d0bb973f1572dad65789f75f33e88f3025524b4bda2206fab8d57b364736f6c634300080d0033";

type TestEasyMathConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestEasyMathConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestEasyMath__factory extends ContractFactory {
  constructor(...args: TestEasyMathConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TestEasyMath";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestEasyMath> {
    return super.deploy(overrides || {}) as Promise<TestEasyMath>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestEasyMath {
    return super.attach(address) as TestEasyMath;
  }
  connect(signer: Signer): TestEasyMath__factory {
    return super.connect(signer) as TestEasyMath__factory;
  }
  static readonly contractName: "TestEasyMath";
  public readonly contractName: "TestEasyMath";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestEasyMathInterface {
    return new utils.Interface(_abi) as TestEasyMathInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestEasyMath {
    return new Contract(address, _abi, signerOrProvider) as TestEasyMath;
  }
}
